// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingPoliciesPanel_root__lkM7s","form":"EditListingPoliciesPanel_form__6r91c","title":"EditListingPoliciesPanel_title__27rsD"};